import * as yup from 'yup'
import { useRuntimeConfig } from '#app'
import { REGEX_SENDER_NAME, REGEX_SPECIAL_CHARACTER } from '~/constants'
import { bankAccountNumberSchema } from '~/validate/forms/common'
import { VALIDATION_ERROR_WITHDRAW_MESSAGE } from '~/validate/constant/validation-message'
import { BANKING_FORM_CRITERIA } from '~/validate/constant/banking-form'
import { PHONE_CARD_FORM_CRITERIA } from '~/validate/constant/phone-card-form'
import { CRYPTO_FORM_CRITERIA } from '~/validate/constant/crypto-form'

export const MIN_AMOUNT = 150
export const MIN_AMOUNT_CRYPTO = 100
export const MAXIMUM_AMOUNT = 299000

let FLAT_CURRENCY_UNIT = ''
let MAIN_CREDIT_UNIT = ''
let AGENCY_CREDIT_UNIT = ''
try {
  const environment = useRuntimeConfig().public
  FLAT_CURRENCY_UNIT = environment.FLAT_CURRENCY_UNIT
  MAIN_CREDIT_UNIT = environment.MAIN_CREDIT_UNIT
  AGENCY_CREDIT_UNIT = environment.AGENCY_CREDIT_UNIT
} catch { /* empty */ }

export const formPhoneCardSchema = yup.object().shape({
  cardAmountUnit: yup
    .string()
    .required('Vui lòng chọn mệnh giá.')
    .test('min', `Mệnh giá tối thiểu là 10,000 ${FLAT_CURRENCY_UNIT}.`, val => Number(val?.replace(/,/g, '')) >= 10000),
  cardNumber: yup
    .number()
    .required('Vui lòng nhập số lượng thẻ.')
    .typeError('Vui lòng nhập số lượng thẻ.')
    .test(
      'max',
      `Số lượng thẻ tối đa là ${PHONE_CARD_FORM_CRITERIA.NUMBER_OF_PHONE_CARD_MAX}`,
      val => val < PHONE_CARD_FORM_CRITERIA.NUMBER_OF_PHONE_CARD_MAX + 1
    )
    .test('min', 'Số lượng thẻ tối thiểu là 1.', val => val > 0)
})
export const formBankSchema = yup.object().shape({
  bankCode: yup.string().required('Vui lòng chọn ngân hàng.'),
  toBankName: yup
    .string()
    .required('Vui lòng nhập tên người nhận.')
    .matches(new RegExp(REGEX_SENDER_NAME), 'Họ và tên người nhận không bao gồm số, các ký tự đặc biệt và dấu.')
    .min(BANKING_FORM_CRITERIA.BANK_NAME_MIN_LENGTH, `
      Họ và tên phải từ ${BANKING_FORM_CRITERIA.BANK_NAME_MIN_LENGTH} tới ${BANKING_FORM_CRITERIA.BANK_NAME_MAX_LENGTH}
      ký tự.
    `),
  toBankNo: bankAccountNumberSchema,
  amountWithdrawMask: yup
    .string()
    .required('Vui lòng nhập số tiền rút.')
    .test('min', `Số tiền rút tối thiểu là 150 ${MAIN_CREDIT_UNIT}.`, val => {
      return Number(val?.replace(/,/g, '')) >= MIN_AMOUNT
    })
    .test('max', `Số tiền rút tối đa là 299,000 ${MAIN_CREDIT_UNIT}.`, val => {
      return Number(val?.replace(/,/g, '')) <= MAXIMUM_AMOUNT
    })
})
export const formUserBankSchema = yup.object().shape({
  bankCode: yup.string().required('Vui lòng chọn ngân hàng.'),
  amountWithdrawMask: yup
    .string()
    .required('Vui lòng nhập số tiền rút.')
    .test('min', `Số tiền rút tối thiểu là 150 ${MAIN_CREDIT_UNIT}.`, val => {
      return Number(val?.replace(/,/g, '')) >= MIN_AMOUNT
    })
    .test('max', `Số tiền rút tối đa là 299,000 ${MAIN_CREDIT_UNIT}.`, val => {
      return Number(val?.replace(/,/g, '')) <= MAXIMUM_AMOUNT
    })
})

export const addBankAccountSchema = yup.object().shape({
  bank_account_name: yup.string()
    .required('Vui lòng nhập họ và tên chủ tài khoản')
    .matches(REGEX_SENDER_NAME, 'Tên tài khoản viết không dấu và không chứa kí tự đặc biệt')
    .min(
      BANKING_FORM_CRITERIA.BANK_NAME_MIN_LENGTH,
      `Vui lòng không nhập ít hơn ${BANKING_FORM_CRITERIA.BANK_NAME_MIN_LENGTH} ký tự`
    ),
  bank_account_no: bankAccountNumberSchema
})

export const formAddCryptoWalletSchema = yup.object().shape({
  walletAddress: yup
    .string()
    .required(VALIDATION_ERROR_WITHDRAW_MESSAGE.REQUIRED_WALLET_ADDRESS)
    .matches(
      new RegExp(REGEX_SPECIAL_CHARACTER),
      VALIDATION_ERROR_WITHDRAW_MESSAGE.INVALID_CHARACTER_CRYPTO_WALLET_ADDRESS
    )
    .test(
      'min-max',
      VALIDATION_ERROR_WITHDRAW_MESSAGE.INVALID_LENGTH_CRYPTO_WALLET_ADDRESS,
      val =>
        val.toString().length >= CRYPTO_FORM_CRITERIA.WALLET_ADDRESS_MIN_LENGTH &&
        val.toString().length <= CRYPTO_FORM_CRITERIA.WALLET_ADDRESS_MAX_LENGTH
    )
})

export const formWithdrawCryptoSchema = yup.object().shape({
  amountWithdrawMask: yup
    .string()
    .required(VALIDATION_ERROR_WITHDRAW_MESSAGE.REQUIRED_AMOUNT)
    .test('maxAmountWithdrawMask', VALIDATION_ERROR_WITHDRAW_MESSAGE.INVALID_BALANCE, (value, context) => {
      const { totalBalance } = context.parent
      return Number(value?.replace(/[^\d.-]/g, '')) <= Number(totalBalance?.replace(/[^\d.-]/g, ''))
    })
    .test('min', `Vui lòng rút tối thiểu 100 ${AGENCY_CREDIT_UNIT}.`, val => {
      return Number(val?.replace(/,/g, '')) >= MIN_AMOUNT_CRYPTO
    })
    .test('max', `Số tiền rút tối đa 299,000 ${AGENCY_CREDIT_UNIT}.`, val => {
      return Number(val?.replace(/,/g, '')) <= MAXIMUM_AMOUNT
    })
})
